/** @namespace KevelAPI */

import axios from 'axios'
const dev = false
const baseUrlAd = 'https://butler.rehabpath.com'

export const baseUrl = dev
  ? 'http://localhost:5001/rehabpath-e97f8/us-central1/kevel/'
  : 'https://us-central1-rehabpath-e97f8.cloudfunctions.net/kevel/'

/** @memberof KevelAPI */
export const recordUrlClick = async (url) => {
  console.log('record click: ', url)
  const urlParts = url.split('https://e-10842.adzerk.net')
  if (urlParts[1]) url = baseUrlAd + urlParts[1]
  axios.get(url).catch((error) => {
    console.log(error)
    console.log(error?.response?.data)
    console.log(error?.response?.status)
  })
}

/** @memberof KevelAPI */
export const recordImpression = async (url) => {
  if (typeof window === 'undefined') return
  console.log('record impression: ', url)
  const urlParts = url.split('https://e-10842.adzerk.net')
  if (urlParts[1]) url = baseUrlAd + urlParts[1]
  axios.get(url).catch((error) => {
    console.log(error)
    console.log(error?.response?.data)
    console.log(error?.response?.status)
  })
}

/** @memberof KevelAPI */
export const recordOrganicImpression = async (slug, zoneId) => {
  if (typeof window === 'undefined') return
  // console.log('record organic impression: ', slug)
  const query = '?impression=true&zoneId=' + zoneId
  const url = baseUrl + 'organic/' + slug + query
  axios.get(url).catch((error) => {
    // console.log(error)
    if (error?.response?.status === 404) return
    // console.log(error?.response?.data);
    // console.log(error?.response?.status);
  })
}

/** @memberof KevelAPI */
export const recordOrganicClick = async (slug, zoneId) => {
  console.log('record organic click: ', slug)
  const query = '?click=true&zoneId=' + zoneId
  const url = baseUrl + 'organic/' + slug + query
  axios.get(url).catch((error) => {
    // console.log(error)
    if (error?.response?.status === 404) return
    // console.log(error?.response?.data);
    // console.log(error?.response?.status);
  })
}

/** @memberof KevelAPI */
export const recordConversion = async (slug) => {
  console.log('record conversion: ', slug)
  const url = baseUrl + 'conversion/' + slug
  axios
    .get(url)
    .then((response) =>
      console.log(
        'conversion: ',
        response.data.conversionRequestStatus,
        response.data.ad.contents
      )
    )
    .catch((error) => {
      console.log(error)
      if (error?.response?.status === 404) return
      // console.log(error?.response?.data);
      // console.log(error?.response?.status);
    })
}
